(() => {
  function slides(gallery) {
    return [...gallery.querySelectorAll('.product__media-list > [data-media-id]')];
  }

  function selectedIndex(gallery, items) {
    const selected = gallery.querySelector('.thumbnail-list [data-target] button[aria-current="true"]');
    const id = selected?.closest('[data-target]')?.dataset.target;
    let index = items.findIndex((item) => item.dataset.mediaId === id);
    if (index < 0) index = items.findIndex((item) => item.classList.contains('is-active'));
    return Math.max(0, index);
  }

  function update(gallery) {
    const items = slides(gallery);
    const index = selectedIndex(gallery, items);
    const prev = gallery.querySelector('.memorra-gallery__arrow--prev');
    const next = gallery.querySelector('.memorra-gallery__arrow--next');
    if (prev) prev.disabled = index === 0;
    if (next) next.disabled = index >= items.length - 1;
    gallery.querySelectorAll('.memorra-gallery__dot').forEach((dot, dotIndex) => {
      const active = dotIndex === index;
      dot.classList.toggle('is-active', active);
      if (active) dot.setAttribute('aria-current', 'true');
      else dot.removeAttribute('aria-current');
    });
  }

  function setup(root = document) {
    root.querySelectorAll('media-gallery.memorra-gallery').forEach((gallery) => {
      if (gallery.dataset.memorraGalleryReady) return;
      gallery.dataset.memorraGalleryReady = 'true';
      const thumbnails = gallery.querySelector('.thumbnail-list');
      if (thumbnails) {
        new MutationObserver(() => update(gallery)).observe(thumbnails, {
          subtree: true,
          attributes: true,
          attributeFilter: ['aria-current'],
        });
      }
      gallery.querySelector('[id^="GalleryViewer"]')?.addEventListener('slideChanged', () => update(gallery));
      update(gallery);
    });
  }

  document.addEventListener('click', (event) => {
    const dot = event.target.closest('media-gallery.memorra-gallery .memorra-gallery__dot');
    if (dot) {
      const gallery = dot.closest('media-gallery');
      const target = slides(gallery)[Number(dot.dataset.index)];
      if (target) gallery.setActiveMedia(target.dataset.mediaId, false);
      update(gallery);
      return;
    }
    const button = event.target.closest('media-gallery.memorra-gallery .memorra-gallery__arrow');
    if (!button) return;
    const gallery = button.closest('media-gallery');
    const items = slides(gallery);
    const step = button.classList.contains('memorra-gallery__arrow--next') ? 1 : -1;
    const target = items[selectedIndex(gallery, items) + step];
    if (!target) return;
    gallery.setActiveMedia(target.dataset.mediaId, false);
    update(gallery);
  });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => setup());
  else setup();
  document.addEventListener('shopify:section:load', (event) => setup(event.target));
})();
